module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic09.e07fe33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic09.png
// module id = 527
// module chunks = 1